module.exports = __webpack_public_path__ + "img/cepsa-min.cb5dfe2f.png";